export const LOCATION_OPTIONS = [
  { value: "help", label: "Get help menu" },
  { value: "person", label: "Person profile indicators" },
  { value: "team", label: "Team profile indicators" },
  { value: "tag", label: "Tag profile indicators" },
];

export const EXTERNAL_CONTENT_TYPE_LINK = "link";

export const LINK_LOCATIONS = {
  HELP: "help",
  APPS: "apps", // Legacy, being phased out
  PERSON: "person",
  TEAM: "team",
  TAG: "tag",
};
